<template>
    <div>
        <loading-custom :loading="loading" />
        <form @submit.prevent="handleSubmit()">
            <div class="body">
                <div class="row">
                    <div class="col-12 col-lg-8">
                        <div class="row mb-4">
                            <div class="col-sm-6">
                                <label for="" class="user--title">รหัสผ่าน</label>
                                <input
                                    type="password"
                                    class="form-control"
                                    v-model="form.password"
                                />
                            </div>
                            <div class="col-sm-6">
                                <label for="" class="user--title"
                                    >ยืนยันรหัสผ่าน</label
                                >
                                <input
                                    type="password"
                                    class="form-control"
                                    v-model="form.confirm_password"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body">
                <div class="tw-w-full text-right">
                    <button class="btn btn-sm btn-success">
                        บันทึก
                    </button>
                    &nbsp;&nbsp;
                    <button
                        type="button"
                        class="btn btn-sm btn-default"
                        @click="back()"
                    >
                        ย้อนกลับ
                    </button>
                </div>
            </div>
        </form>
    </div>
    
</template>
<script>
export default {
    props: {
        shop: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            form: {
                password: "",
                confirm_password: ""
            },
            loading: false,
        };
    },
    methods: {
        async handleSubmit() {
            const { password, confirm_password } = this.form;
            if (password.length < 8) {
                this.messageAlert(
                    "error",
                    "รหัสผ่านไม่ปลอดภัย",
                    "กรุณาตั้งรหัสผ่านอย่างน้อย 8 ตัวอักษร"
                );
            } else if (password != confirm_password) {
                this.messageAlert(
                    "error",
                    "ยืนยันรหัสผ่านไม่ถูกต้อง",
                    "รหัสผ่าน และ ยืนยันรหัสผ่านไม่ตรงกัน"
                );
            } else if (password != "" && password === confirm_password) {
                this.loading = true;
                await axios
                    .post(
                        `/backend/s/${this.shop}/user-setting/password`,
                        this.form
                    )
                    .then(res => {
                        this.loading = false;
                        this.back();
                    })
                    .catch(err => {
                        this.messageAlert(
                            "error",
                            "Sorry",
                            "ไม่สามารถทำรายการได้กรุณาลองใหม่อีกครั้ง"
                        );
                    });
            }
        },
        back() {
            window.history.go(-1);
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        }
    }
};
</script>
